module.exports = __webpack_public_path__ + "media/images/landing/icon-boxing-day-3eef02875925322dc9d834e05753129b.svg";